export const Id = 'id'
export const Name = 'project_name'
export const PropertyType = 'property_type'
export const ConstructionType = 'type_of_constructions'
export const ConstructionArea = 'construction_area'

export const GroundFloors = 'floors_above'
export const BasementFloors = 'floors_below'
export const ConstructionStartDate = 'construction_start'
export const ConstructionEndDate = 'completion_date'

export const PostalCode = 'post_code'
export const StateOrPrefecture = 'prefectures'
export const City = 'city'
export const Street = 'town'
export const Building = 'address'
